import React, { useEffect, useLayoutEffect, useState } from "react";

export default function Loading() {
  const [phase, setPhase] = useState("holding");
  useLayoutEffect(() => {
    if (phase !== "holding") return;
    const root = document.documentElement;
    const themeColor = document.querySelector('meta[name="theme-color"]');
    const previousThemeColor = themeColor?.getAttribute("content");
    // Safari's translucent bars can show content outside a fixed overlay.
    // Hide the underlying page without changing its layout or restored scroll.
    root.classList.add("rg-opening-active");
    themeColor?.setAttribute("content", "#ffffff");
    return () => {
      root.classList.remove("rg-opening-active");
      if (themeColor) {
        if (previousThemeColor === null) themeColor.removeAttribute("content");
        else themeColor.setAttribute("content", previousThemeColor);
      }
    };
  }, [phase]);

  useEffect(() => {
    const timeout = window.setTimeout(() => setPhase("done"), 2100);
    return () => window.clearTimeout(timeout);
  }, []);
  const handleAnimation = event => {
    if (event.target !== event.currentTarget || event.animationName !== "rg-loader-slide-away") return;
    setPhase(event.type === "animationstart" ? "revealing" : "done");
  };
  if (phase === "done") return null;
  return (
    <div className="rg-opening-loader" aria-label="Loading website" onAnimationStart={handleAnimation} onAnimationEnd={handleAnimation}>
      <img className="rg-opening-logo" src="/assets/img/logo/logo.png" alt="Resham Gurung" />
    </div>
  );
}
